import { Box, styled } from '@mui/material';

export const PLAYBACK = 'playback';
export const TITLE = 'title';
export const DURATION = 'duration';
export const PROGRESS = 'progress';
export const STUDIO_BUTTON = 'studioButton';
export const RELEASE_BUTTON = 'releaseButton';
export const COPY_LINK = 'copyLink';
export const ADD_TO_LIBRARY = 'addToLibrary';
export const DOWNLOAD = 'download';
export const MENU_BUTTON = 'menuButton';

const gridTemplate = {
  xs: `'${PLAYBACK} ${TITLE}    ${MENU_BUTTON}'
             '${PLAYBACK} ${DURATION} ${MENU_BUTTON}'`,
  md: `'${PLAYBACK} ${TITLE} ${DURATION} ${MENU_BUTTON}'`,
  desktop: `'${PLAYBACK} ${TITLE} ${DURATION} ${PROGRESS} ${STUDIO_BUTTON} ${RELEASE_BUTTON} ${COPY_LINK} ${ADD_TO_LIBRARY} ${DOWNLOAD}'`,
  lg: `'${PLAYBACK} ${TITLE} ${DURATION} ${PROGRESS} ${STUDIO_BUTTON} ${RELEASE_BUTTON} ${COPY_LINK} ${ADD_TO_LIBRARY} ${DOWNLOAD}'`,
  xl: `'${PLAYBACK} ${TITLE} ${DURATION} ${PROGRESS} ${STUDIO_BUTTON} ${RELEASE_BUTTON} ${COPY_LINK} ${ADD_TO_LIBRARY} ${DOWNLOAD}'`,
};

const gridTemplateColumns = {
  xs: '10% 70% 10%',
  md: '10% 50% 20% 10%',
  desktop:
    '33px minmax(150px, 24%) 33px minmax(50px, 20%) 20px 20px 20px 20px 20px',
  lg: '33px minmax(150px, 24%) 33px minmax(100px, 30%) 100px 100px 20px 20px 20px',
  xl: '33px 24% 33px minmax(30%, 280px) 100px 100px 20px 20px 20px',
};

export const TrackGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  alignItems: 'center',
  alignContent: 'center',
  justifyContent: 'space-around',
  [theme.breakpoints.up('xs')]: {
    height: theme.spacing(10),
    padding: theme.spacing(0, 1),
    gridTemplate: gridTemplate.xs,
    gridTemplateColumns: gridTemplateColumns.xs,
  },
  [theme.breakpoints.up('md')]: {
    height: theme.spacing(10),
    padding: theme.spacing(0, 2),
    gridTemplate: gridTemplate.md,
    gridTemplateColumns: gridTemplateColumns.md,
  },
  [theme.breakpoints.up('desktop')]: {
    height: theme.spacing(10),
    padding: theme.spacing(0, 2),
    gridTemplate: gridTemplate.desktop,
    gridTemplateColumns: gridTemplateColumns.desktop,
  },
  [theme.breakpoints.up('lg')]: {
    height: theme.spacing(11),
    gridColumnGap: theme.spacing(2),
    gridTemplate: gridTemplate.lg,
    gridTemplateColumns: gridTemplateColumns.lg,
  },
  [theme.breakpoints.up('xl')]: {
    height: theme.spacing(11),
    gridColumnGap: theme.spacing(2),
    gridTemplate: gridTemplate.xl,
    gridTemplateColumns: gridTemplateColumns.xl,
  },
}));

export const TrackGridCeil = styled(Box)(() => ({
  width: '100%',
}));

export const TrackPlayback = styled(TrackGridCeil)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignSelf: 'center',
  gridArea: PLAYBACK,
}));

export const TrackTitle = styled(TrackGridCeil)(({ theme }) => ({
  gridArea: TITLE,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  alignSelf: 'center',
  [theme.breakpoints.down('md')]: {
    fontSize: 14,
  },
}));

export const TrackDuration = styled(TrackGridCeil)(({ theme }) => ({
  gridArea: DURATION,
  alignSelf: 'center',
  [theme.breakpoints.down('md')]: {
    fontSize: 12,
    color: theme.palette.grey[400],
  },
}));

export const TrackProgress = styled(TrackGridCeil)(({ theme }) => ({
  gridArea: PROGRESS,
  [theme.breakpoints.down('desktop')]: {
    display: 'none',
  },
}));

export const StudioButtonSlot = styled(TrackGridCeil)(({ theme }) => ({
  gridArea: STUDIO_BUTTON,
  [theme.breakpoints.down('desktop')]: { display: 'none' },
}));

export const ReleaseButtonSlot = styled(TrackGridCeil)(({ theme }) => ({
  gridArea: RELEASE_BUTTON,
  [theme.breakpoints.down('desktop')]: { display: 'none' },
}));

export const TrackCopyLink = styled(TrackGridCeil)(({ theme }) => ({
  gridArea: COPY_LINK,
  [theme.breakpoints.down('desktop')]: { display: 'none' },
}));

export const TrackAddToLibrary = styled(TrackGridCeil)(({ theme }) => ({
  gridArea: ADD_TO_LIBRARY,
  [theme.breakpoints.down('desktop')]: { display: 'none' },
}));

export const TrackDownload = styled(TrackGridCeil)(({ theme }) => ({
  gridArea: DOWNLOAD,
  [theme.breakpoints.down('desktop')]: { display: 'none' },
}));

export const MenuButton = styled(TrackGridCeil)(({ theme }) => ({
  gridArea: MENU_BUTTON,
  [theme.breakpoints.up('desktop')]: { display: 'none' },
}));
